export const Statuses = {
    LOADING: "loading",
    REVALIDATING: "revalidating",
    IDLE: "idle",
    SUBMITTING: "submitting",
};